import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mobileOtpToken: localStorage.getItem('mobileOtpToken') || null,
};

const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {

    setMobileOtpToken: (state, action) => {
      state.mobileOtpToken = action.payload;

      if (action.payload) {
        localStorage.setItem('mobileOtpToken', action.payload);
      } else {
        localStorage.removeItem('mobileOtpToken');
      }
    },

    clearMobileOtpToken: (state) => {
      state.mobileOtpToken = null;
      localStorage.removeItem('mobileOtpToken');
    },
  },
});

export const {
  setMobileOtpToken,
  clearMobileOtpToken
} = signupSlice.actions;

export default signupSlice.reducer;
